import { JobList } from "../../components/jobList";
import { SearchBar } from "../../components/searchBar";
import { GigPreview } from "../../hooks/models/GigPreview";
import { useGetMyGigs } from "../../hooks/gig-hooks";
import { useState, useEffect } from "react";
import { CandidateItemProps } from "../../components/candidateItem/model";
import { getAllCandidates } from "../../services/candidates-service";
import { getMyGigs } from "../../services/gig-service";

export const Jobs = () => {
    const [gigs, setGigs] = useState<Array<GigPreview>>();
    const [filteredGigs, setFilteredGigs] =useState<Array<GigPreview>>();
    const [searchString, setSearchString] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        getGigs()
    }, [])

    const searchByString = (string) => {
        setSearchString(string);

        setFilteredGigs(
            gigs.filter(
                (gig) =>
                    gig.gigTitle && gig.gigTitle.toLowerCase().includes(string.toLowerCase()) ||
                    gig.location && gig.location.toLowerCase().includes(string.toLowerCase()) ||
                    gig.category && gig.category.toLowerCase().includes(string.toLowerCase())
            )
        );
    };

    const getGigs = async () => {
        setIsLoading(true);

        const response = (await getMyGigs()) as Array<GigPreview>;

        setGigs(response);
        setFilteredGigs(response);

        setIsLoading(false);
    };



    return (
        <div className="flex flex-col h-full">
            <div className="px-4 py-4 sm:px-6 sm:py-6 flex-shrink-0">
                <SearchBar text="Caută job" onChange={(e) => searchByString((e.target as HTMLInputElement).value)} />

                <div className="mt-6 sm:mt-8">
                    <h3 className="page-title text-[24px] sm:text-[28px] md:text-[32px]">Joburile tale</h3>
                    <p className="page-description text-sm sm:text-base">Pozițiile tale active</p>
                </div>
            </div>

            <div className="flex-1 overflow-y-auto px-4 pb-6 sm:px-6">
                {filteredGigs ? <JobList jobs={filteredGigs} loading={isLoading} onChanged={getGigs} /> : ""}
            </div>
        </div>
    )
}